import Fight from './Fight';
import Shop from './Shop';
import Fountain from './Fountain';
import Treasure from './Treasure';
import Celestial from './Celestial';
import Collectable from './Collectable';
import Library from '../utility/Library';
import User from '../../User';
import Script from './Script';

const EVENT_CHANCES = {
	chest: 0.08,
	fight: 0.15,
	fountain: 0.02,
	shop: 0.03,
	menagerie: 0.01,
	treasure: 0.02,
	event: 0.69
}

const REWARD_CHANCES = {
	card: 0.31,
	seed: 0.23,
	coin: 0.23,
	berry: 0.23
}

const eventForRun = (run, type) => Object.values(Library.getEvents(run.power)).find(event => event.type === type);

const START_POWER_ORBS = {
	2: "power-orb",
	3: "power-orb-2"
}

const POWER_ORB_HOLDER_ENTITY = {
	id: { type: "power-orb-holder", no: 1 },
	name: "Anala",
	img: "https://moa-pull.b-cdn.net/assets/events/anala.png",
	scale: 0.95
}

function pickAtRandom(chances) {
	const rand = Math.random();
	let cumulative = 0;

	for (const [key, chance] of Object.entries(chances)) {
		cumulative += chance;
		if (rand < cumulative) {
			return key;
		}
	}
}

function chooseReward(difficulty, usedRewards) {
	return pickAtRandom(REWARD_CHANCES);
    const rewards = REWARD_CHANCES[difficulty];
    let reward;

    do {
        const roll = Math.random();
        let cumulative = 0;

        for (const r of rewards) {
            cumulative += r.chance;
            if (roll < cumulative) {
                reward = r;
                break;
            }
        }
    } while (!reward.multiple && usedRewards.includes(reward.type));

    return reward.type;
}

function getAct(run) {

	return run.actModel || Object.values(Library.acts).find(act => act.act === run.floor);
}

function getActFights(run) {

	const act = getAct(run);
	const fights = act?.fights?.[run.power] || [];
	return fights.map(fight => Object.assign({}, fight, {
		act: act.key,
		floor: act.act,
		power: run.power
	}));
}

export default class Room {

	constructor (run, model) {

		this.run = run;
		this.model = model;
		this.entities = [];
		this.collectables = [];
		this.variables = {};
		this.run.notify('newroom', this);
	}

	get type () {

		return this.model.type;
	}

	init () {

		let real_type = this.type;
		if (this.type === "event") {
			// Preserve the unknown-room origin when its encounter changes the type.
			this.model.unknownRoom = true;

			if (this.run.champion.getPassive('unknownfountain') && this.model.type !== "fountain") {
				if (Math.random() < (this.run.pityTimerRelicEvent-1)/3) {
					Object.assign(this.model, { type: 'fountain' });
					this.run.pityTimerRelicEvent = 0;
				} else
					this.run.pityTimerRelicEvent++;
			} else if (this.run.champion.getPassive('unknowntreasure') && this.model.type !== "treasure") {
				if (Math.random() < (this.run.pityTimerRelicEvent-1)/3) {
					Object.assign(this.model, { type: 'treasure' });
					this.run.pityTimerRelicEvent = 0;
				} else
					this.run.pityTimerRelicEvent++;
			}

			if (this.type === "event") {

				real_type = pickAtRandom(EVENT_CHANCES);
				let rerolleventtype = true;
				while (rerolleventtype) {
					real_type = pickAtRandom(EVENT_CHANCES);
					if (this.run.power < 2 && real_type === "menagerie")
						rerolleventtype = true;
					else
						rerolleventtype = false;
				}

				switch (real_type) {
				case "chest": Object.assign(this.model, { type: 'chest' }); break;
				case "fight": {
					const roomNumber = this.run.rooms.length - 1;
					const difficulty = roomNumber >= 8 ? "hard" : "normal";
					const reward = chooseReward(difficulty, []);
	                Object.assign(this.model, { type: 'fight', difficulty, reward });
	                break;
				}
				case "shop": Object.assign(this.model, eventForRun(this.run, "shop"), { type: 'shop' }); break;
				case "menagerie": Object.assign(this.model, eventForRun(this.run, "menagerie"), { type: 'menagerie' }); break;
				case "fountain": Object.assign(this.model, { type: 'fountain' }); break;
				case "treasure": Object.assign(this.model, { type: 'treasure' }); break;
				case "event": {
					let events = Object.values(Library.getEvents(this.run.power));
					let memoryvalue = this.run.power + (this.run.floor >= 3 ? 1 : 0);
					events = events.filter(r => r.type === "event" && !r.conditional && Library.eventAvailableForRun(r, this.run));
					if (User.dataFor(this.run.champion.model.key, User.difficulty).progress <= memoryvalue)
						events = events.filter(r => !r.memory);
					let possibleEvents = events.filter(r => !this.run.usedEvents.includes(r.key));
					if (possibleEvents.length === 0) {
						possibleEvents = events;
						this.run.usedEvents = [];
					}
					// Build total weight
					let totalWeight = possibleEvents.reduce((sum, r) => {
					    return sum + (1 / (r.rarity || 1));
					}, 0);
					// Pick weighted random
					let random = Math.random() * totalWeight;
					let cumulative = 0;
					let selectedEvent = possibleEvents.find(r => {
					    cumulative += (1 / (r.rarity || 1));
					    return random < cumulative;
					});
					// Fallback safety (in case something goes wrong)
					selectedEvent = selectedEvent || possibleEvents[possibleEvents.length - 1];
					this.run.usedEvents.push(selectedEvent.key);
					Object.assign(this.model, selectedEvent);
					break;
				}
				}
			}
		}

		switch (this.type) {
		case "start":
			const actDepth = this.run.actModel?.act || this.run.floor;
			const powerOrb = START_POWER_ORBS[actDepth];
			if (powerOrb) {
				this.addEntity(POWER_ORB_HOLDER_ENTITY);
				this.addCollectable("relic", Library.upgradeItem(Library.getRelic(powerOrb), this.run.power));
			}
			break;
		case "amaryllis":
			this.celestial = new Celestial(this.run, "amaryllis");
			break;
		case "aurora":
			this.celestial = new Celestial(this.run, "aurora");
			break;
		case "zephyrus":
			this.celestial = new Celestial(this.run, "zephyrus");
			break;
		case "nikara":
			this.celestial = new Celestial(this.run, "nikara");
			break;
		case "nilith":
			this.celestial = new Celestial(this.run, "nilith");
			break;
		case "event":
			Script.read(this, this.model.script);
			this.addEntity(this.model.entity);
			break;
		case "story":{
			this.fight = new Fight(this.run);
			this.fight.start(this.model.slots || this.model.enemies);
			break;
		}
		case "fight": {
			let memoryvalue = this.run.power + (this.run.floor >= 3 ? 1 : 0);
			if (this.model.difficulty === "memory" && User.dataFor(this.run.champion.model.key, User.difficulty).progress > memoryvalue) {
				let quest = Object.values(Library.quests).filter(quest => quest.champion === this.run.champion.model.key && quest.value === memoryvalue)[0];
				this.model = Object.assign({}, this.model, {
					difficulty: 5,
					power: this.run.power,
					slots: quest.enemies.map(enemy => ({ enemy }))
				});
			} else {

				let difficulty = this.model.difficulty === "hard" ? 3 : (this.model.difficulty === "easy" ? 1 : 2);
				let fights = getActFights(this.run).filter(r => r.type === "fight" && r.difficulty === difficulty);
				let remaining = fights.filter(r => !this.run.usedFights.includes(r.key))
				if (remaining.length === 0) {
					this.run.usedFights = [];
					remaining = fights;
				}
				let model = remaining[Math.floor(Math.random() * remaining.length)];
				this.model = Object.assign({}, this.model, model);
			}
			this.reward = this.model.reward;
			this.fight = new Fight(this.run);
			this.fight.start(this.model.slots || this.model.enemies);
			this.run.usedFights.push(this.model.key);
			break;
		}
		case "boss": {
			let bosses = getActFights(this.run).filter(r => r.type === "boss");
			let model = bosses[Math.floor(Math.random() * bosses.length)];
			this.model = Object.assign({}, this.model, model);
			this.reward = this.model.reward;
			this.fight = new Fight(this.run);
			this.fight.start(this.model.slots || this.model.enemies);
			break;
		}
		case "shop":
			if (this.run.champion.getPassive("shopgold"))
				this.run.champion.gainGold(this.run.champion.getPassive("shopgold"));
			if (this.run.champion.getPassive("shopheal"))
				this.run.champion.heal(this.run.champion.getPassive("shopheal"));
			//this.shop = new Shop(this.run);
			//this.shop.fill();
			Script.read(this, this.model.script);
			this.addEntity(this.model.entity);
			break;
		case "menagerie":
			Script.read(this, this.model.script);
			this.addEntity(this.model.entity);
			break;
		case "fountain":
			this.fountain = new Fountain(this.run);
			break;
		case "chest":
			this.treasure = new Treasure(this.run, "chest");
			let nbtreasures = Math.random() < 0.5 ? 3 : 2;
			for (let i = 0; i < nbtreasures; i++) {
				let treasuretypes = ["cardchoice", "cardchoice", "item", "item", "item", "item", "item", "item", "gold", "gold", "gold", "gold", "card", "card", "card", "card"]
					.filter(type => !this.treasure.collectables.some(col => col.type === "item" ? false : col.type === type))
				let treasuretype = treasuretypes[Math.floor(Math.random() * treasuretypes.length)];
				switch (treasuretype) {
				case "cardchoice": this.treasure.generateTreasure("cardchoice", 3); break;
				case "card": this.treasure.generateTreasure("card", this.run.generateCardChoices(1)[0]); break;
				case "item": this.treasure.generateItem(); break;
				case "gold": this.treasure.generateTreasure("gold", Math.round((2+this.run.floor) * (2 + Math.random() * 10))); break;
				case "remove": this.treasure.generateTreasure("remove"); break;
				case "remove": this.treasure.generateTreasure("paws"); break;
				//case "insight": this.treasure.generateTreasure("insight", Math.round(1 + Math.random() * 2)); break;
				}
			}
			break;
		case "treasure":
			this.treasure = new Treasure(this.run);
			this.treasure.generateRelic();
			break;
		case "altar":
			this.treasure = new Treasure(this.run, "altar");
			if (this.run.floor < 4)
				this.treasure.generateTreasure("key", this.run.maxFloor+1);
			else if (this.run.traits.maze < User.contentLimits(this.run.champion.model.key).mazePower && this.run.power === this.run.traits.maze)
				this.treasure.generateTreasure("power");
			else
				this.treasure.generateTreasure("escape");
			break;
		default: break;
		}

		this.initialized = true;
		this.run.notify('initroom', this);
	}

	clear () {

		delete this.shop;
		delete this.fight;
		delete this.fountain;
		delete this.treasure;
		this.entities = [];
		this.run.notify('clearroom', this);
	}

	setChoices (text, choices) {

		this.choiceText = text;
		this.choices = choices.map(choice => {
			if (!choice.repeatUntilCurse)
				return choice;
			const repeatUntilCurse = { ...choice.repeatUntilCurse };
			return {
				...choice,
				repeatUntilCurse,
				description: choice.descriptionTemplate.replace('<chance>', repeatUntilCurse.chance)
			};
		});
		this.run.notify('setchoices', this, text, this.choices);
	}

	computeEventValue (value) {

		if (typeof value === "number" && !isNaN(value))
			return value;

		switch (value) {
		case "floor": return this.run.floor;
		case "level": return this.run.champion.level;
		case "gold": return this.run.champion.gold;
		//case "insight": return this.run.insight;
		case "runes": return 0;
		case "benevolence": return this.run.benevolence;
		case "corruption": return this.run.champion.corruption;
		case "exp": return this.run.champion.exp;
		default: break;
		}

		switch (value && value.op) {
		case "times": return value.values.reduce((acc, x) => acc * this.computeEventValue(x), 1);
		case "minus": return this.computeEventValue(value.values[0]) - this.computeEventValue(value.values[1]);
		case "div": return Math.floor(this.computeEventValue(value.values[0]) / this.computeEventValue(value.values[1]));
		case "plus": return value.values.reduce((acc, x) => acc + this.computeEventValue(x), 0);
		default: return value;
		}

		return value;
	}

	canSelectChoice (n) {

		if (!this.choices)
			return;
		const choice = this.choices[n];
		if (!choice.condition)
			return true;

		return choice.condition.every(c => {

			if (c.check === "relic") {
				return this.run.champion.relics.some(r => r.key === c.value);
			} else if (c.check === "nocurse") {
				return !this.run.champion.curses.some(curse => curse.key === c.value);
			} else if (c.over != undefined) {
				const check = this.computeEventValue(c.check);
				const over = this.computeEventValue(c.over);
				return check >= over;
			}
			return true;
		})
	}

	selectChoice (n) {

		if (!this.canSelectChoice(n))
			return;
		const choice = this.choices[n];
		choice.effect.forEach(e => {
			let value = e.value ? this.computeEventValue(e.value) : 0;
			switch (e.type) {
			case "exp": this.run.champion.gainExp(value); break;
			case "hp": this.run.champion.heal(value); break;
			case "maxhp": this.run.champion.gainMaxHp(value); break;
			case "gold": if (value > 0) this.run.champion.gainGold(value); else this.run.champion.loseGold(-value); break;
			case "benevolence": this.run.addBenevolence(value); break;
			case "corruption": this.run.champion.gainCorruption(value); break;
			case "curse": this.run.champion.applyCurse(e.value); break;
			case "card": this.run.addCard(Library.upgradeItem(Library.getCard(value), this.run.power), false); break;
			case "commons": this.run.addRandomCard(value, c => c.rarity && c.rarity === 1); break;
			case "uncommons": this.run.addRandomCard(value, c => c.rarity && c.rarity === 2); break;
			case "rares": this.run.addRandomCard(value, c => c.rarity && c.rarity === 3); break;
			case "damage": this.run.champion.loseLife(value); break;
			case "remove": this.run.dropChoice(true); break;
			//case "insight": this.run.addInsight(value); break;
			case "entropy": this.run.changeMinDeckSize(value); break;
			case "duplicate": this.run.duplicateChoice(); break;
			case "relic": this.run.champion.newRelic(Library.upgradeItem(Library.getRelic(value), this.run.power)); break;
			case "potion": this.run.champion.newPotion(Library.getPotion(value)); break;
			case "loserelic": this.run.champion.loseRelic(value); break;
			case "fight": this.becomeFight(); break;
			case "hardfight": this.becomeFight("hard"); break;
			case "memory": this.becomeFight("memory"); break;
			default: break;
			}
		})
		if (choice.repeatUntilCurse) {
			const repeat = choice.repeatUntilCurse;
			const curseRolled = Math.random() < repeat.chance / 100;
			if (curseRolled)
				this.run.champion.applyCurse(repeat.curse);
			if (!curseRolled) {
				repeat.chance = Math.min(100, repeat.chance + repeat.increment);
				this.setChoices(this.choiceText, this.choices);
				return;
			}
		}
		this.choiceText = null;
		this.choices = null;
		this.run.notify('setchoices', this, undefined);
	}

	becomeFight (difficulty="normal") {

		let fightreward = null;
	    let cumulative = 0;
	    if (difficulty === "hard") {
	    	let roll = Math.random();
		    if (roll < 0.25)
		    	fightreward = "relic";
		    else if (this.run.power > 1 && roll < 0.375)
		    	fightreward = "paws";
		    else {
		    	const possiblerewards = ["card", "seed", "berry", "coin"];
		    	fightreward = [null, null];
		    	fightreward[0] = possiblerewards[Math.floor(Math.random() * possiblerewards.length)];
		    	while (!fightreward[1] && fightreward[0] === fightreward[1])
		    		fightreward[1] = possiblerewards[Math.floor(Math.random() * possiblerewards.length)];
		    }
			this.model = Object.assign({}, this.model, {
				type: "fight",
				difficulty: "hard",
				reward: fightreward
			});
		} else if (difficulty === "memory") {
			this.model = Object.assign({}, this.model, {
				type: "fight",
				difficulty: "memory",
				reward: "relic"
			});
		} else {
	    	const possiblerewards = ["card", "seed", "berry", "coin"];
	    	fightreward = possiblerewards[Math.floor(Math.random() * possiblerewards.length)];
			this.model = Object.assign({}, this.model, {
				type: "fight",
				difficulty: "normal",
				reward: fightreward
			});
		}
		this.run.room.clear();
		this.run.room.init();
	}

	addEntity (entity) {

		this.entities.push(entity);
		this.run.notify('addentity', this, entity);
	}

	setSpirit (key) {

		this.spirit = key ? Library.getSpirit(key) : null;
		this.run.notify('setspirit', this, this.spirit);
	}

	enter (timer=true) {//setTimeout(() => this.run.champion.gainExp(100), 3000);

		if (this.run.room && this.run.room !== this)
			this.run.room.cleanup();
		this.run.champion.loseCorruption(1);
		if (this.type !== "start")
			this.run.deck.forEach(c => delete c.new);
		this.run.rooms.push(this);
		if (this.type !== "altar" && !this.model.afterBoss) {
			this.run.time--;
			if (this.run.plan.length > 0) {
				if (this.run.plan[0] === this.model.index)
					this.run.plan.shift();
				else
					this.run.plan = [];
			}
		}
		this.run.notify('enterroom', this);
		if (!this.initialized)
			this.init();
		if (this.type === "fountain" && this.run.champion.getPassive("enterfountainheal"))
			this.run.champion.heal(this.run.champion.getPassive("enterfountainheal"));
		if (this.celestial && !this.variables.celestialHealingApplied && this.run.champion.getPassive("entercelestialheal")) {
			this.variables.celestialHealingApplied = true;
			this.run.champion.heal(this.run.champion.getPassive("entercelestialheal"));
		}
	}

	cleanup () {

		if (!this.fight && !this.shop && !this.fountain && !this.treasure)
			return;
		//this.run.notify("timedown", this.run);
		//this.run.time--;
		let lvup = this.run.champion.checkLevelUp();
		delete this.fight;
		delete this.shop;
		delete this.fountain;
		delete this.treasure;
		this.run.notify("roomcleanup", this);
		//this.run.next();
	}

	addCollectable (type, value) {

		this.collectables.push(new Collectable(this.run, type, value));
		switch (type) {
		case "card": User.learn("cards", value.key);
		case "relic": User.learn("relics", value.key);
		case "item": User.learn("potions", value.key);
		default: break;
		}
		this.run.notify("roomcollectable", this, type, value);
	}

	changeCollectable (index, value) {

		const col = this.collectables[index];
		col.value = value;
		this.run.notify("roomchangecollectable", this, index, value);
	}

	collect (index) {

		const col = this.collectables[index];
		col.collect();
		this.collectables[index] = null;
		this.run.notify("roomcollect", this, index);
	}

	collectAll () {

		for (let i = this.collectables.length-1; i >= 0; i--)
			if (this.collectables[i])
				this.collect(i);
	}

	serialize () {

		return {
			model: this.model,
			initialized: this.initialized,
			fight: this.fight?.serialize(),
			shop: this.shop?.serialize(),
			fountain: this.fountain?.serialize(),
			treasure: this.treasure?.serialize(),
			celestial: this.celestial?.serialize(),
			entities: this.entities.map(e => Object.assign({}, e)),
			collectables: this.collectables.map(c => c ? c.serialize() : null),
			reward: this.reward,
			choiceText: this.choiceText,
			choices: this.choices,
			variables: Object.assign({}, this.variables)
		}
	}

	static build (run, src) {

		let room = new Room(run, src.model);
		room.initialized = src.initialized;
		room.spirit = src.spirit ? Library.getSpirit(src.spirit) : null;
		room.entities = src.entities.map(e => Object.assign({}, e));
		room.collectables = src.collectables.map(c => c && c.type !== "shards" ? Collectable.build(run, c) : null);
		room.reward = src.reward;
		room.choiceText = src.choiceText;
		room.choices = src.choices;
		room.variables = Object.assign({}, src.variables);
		if (src.fight)
			room.fight = Fight.build(run, src.fight);
		if (src.shop)
			room.shop = Shop.build(run, src.shop);
		if (src.fountain)
			room.fountain = Fountain.build(run, src.fountain);
		if (src.treasure)
			room.treasure = Treasure.build(run, src.treasure);
		if (src.celestial)
			room.celestial = Celestial.build(run, src.celestial);
		return room;
	}
}
